import { GradientButtonOutline } from "./GradientButton";

export const BackButton = ({ onClick, ...props }) => {
  return (
    <GradientButtonOutline
      onClick={onClick}
      {...props}
      sx={{
        px: 3,
        display: "flex",
        alignItems: "center",
        height: "40px",
        backgroundColor: "white",
      }}
    >
      กลับ
    </GradientButtonOutline>
  );
};
